<script setup lang="ts">
type TooltipProps = {
  location?: 'start' | 'end' | 'top' | 'bottom';
};

const props = defineProps<TooltipProps>();
const model = defineModel<boolean>();
</script>
<template>
  <v-tooltip
    v-model="model"
    :location="props.location || 'top'"
    activator="parent"
  >
    <slot />
  </v-tooltip>
</template>
<style scoped lang="scss">
:deep(.v-overlay__content) {
  background-color: white !important;
  border: 1px solid rgb(var(--v-theme-neutral));
  color: rgb(var(--v-theme-neutral)) !important;
}
</style>
